export default {
    billingPlans: 'getBillingPlans',
    billingSummary: 'getBillingSummary',
    currentSubscription: 'loadUserSubscription',
    directories: 'loadDirectories',
    integrations: 'loadIntegrations',
    invoices: 'loadInvoices',
    planFeatures: 'loadPlanFeatures',
    profileControls: 'loadProfileControls',
    showCategories: 'loadShowCategories',
    shows: 'loadShows',
    upcomingInvoice: 'loadUpcomingInvoice',
    userSubscription: 'loadUserSubscription',
};
